import { LT_FEATURE_FLAG_UPDATE } from '../constants/featureFlag';
import { CALL_API } from '../middleware/api';
import { getCookieData } from 'utils/cookieHandler';

const HYPERTEST_SENTINEL_API_ENDPOINT =
  process.env.REACT_APP_HYPERTEST_SENTINEL_API_ENDPOINT;

export const setFeatureFlags = (auth) => {
  const cookieName = process.env.REACT_APP_COOKIE_NAME;
  const access_token = getCookieData(cookieName);
  const headers = {
    Authorization: `Bearer ${access_token}`,
    Accept: 'application/json',
  };

  let sentinelUrl = HYPERTEST_SENTINEL_API_ENDPOINT;
  return {
    [CALL_API]: {
      types: ['', LT_FEATURE_FLAG_UPDATE],
      endpoint: `${sentinelUrl}/v1.0/featureflags`,
      method: 'GET',
      appendBaseUrl: false,
      type: 'json',
      headers,
      auth,
    },
  };
};
